import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { useMe } from "@/context/MeContext";
import { profileStrength } from "@/lib/profile";

export function ProfileStrengthCard() {
  const { me } = useMe();
  const { percent, missing } = profileStrength(me);
  if (percent === 100) return null;
  return (
    <section className="panel p-5 border-sky-200 bg-sky-50/50" data-testid="profile-strength-card">
      <div className="flex items-center justify-between gap-3">
        <p className="font-bold flex items-center gap-2"><Sparkles size={16} className="text-amber-500" />Profile strength</p>
        <span className="font-mono text-sm font-bold text-sky-700" data-testid="profile-strength-percent">{percent}%</span>
      </div>
      <Progress value={percent} className="mt-3 h-2" />
      <p className="mt-3 text-sm text-slate-600">Complete profiles get contacted first. Still missing:</p>
      <div className="mt-2 flex flex-wrap gap-1.5" data-testid="profile-strength-missing">
        {missing.map((m) => <span key={m} className="px-2 py-0.5 rounded-full border border-slate-300 bg-white text-xs">{m}</span>)}
      </div>
    </section>
  );
}

export function ProfileNudge() {
  const { me } = useMe();
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("nudge-hidden") === "1");
  const { percent, missing } = profileStrength(me);
  if (percent === 100 || hidden || pathname === "/profile") return null;
  return (
    <div className="bg-sky-50 border-b border-sky-200" data-testid="profile-nudge-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 text-sm">
        <div className="hidden sm:block w-28"><Progress value={percent} className="h-1.5" /></div>
        <p className="flex-1">
          Your profile is <b data-testid="profile-nudge-percent">{percent}%</b> complete. Add {missing.slice(0, 2).join(" and ").toLowerCase()} to stand out.
        </p>
        <Link to="/profile" className="font-semibold text-sky-700 hover:text-sky-900 whitespace-nowrap" data-testid="profile-nudge-link">Complete</Link>
        <button aria-label="Dismiss" data-testid="profile-nudge-dismiss" onClick={() => { sessionStorage.setItem("nudge-hidden", "1"); setHidden(true); }}><X size={16} /></button>
      </div>
    </div>
  );
}
